/**
 * Spanish display strings for the chat widget, keyed by the English source
 * string. Stored lead values (option `value`, `set` fields) stay English so
 * the backend payload is identical in both languages; only what the visitor
 * sees is translated. test/ should assert every chat string has an entry.
 */
export const CHAT_ES: Record<string, string> = {
  "Sending your details…": "Enviando sus datos…",
  "We couldn't submit your details. Please retry or call us.": "No pudimos enviar sus datos. Inténtelo de nuevo o llámenos.",
  "Retry submission": "Reintentar envío",
  "11 to 25 trailers": "11 a 25 remolques",
  "2 to 5 trailers": "2 a 5 remolques",
  "6 to 10 trailers": "6 a 10 remolques",
  "Agriculture": "Agricultura",
  "Another language": "Otro idioma",
  "Arabic": "Árabe",
  "Are you replacing an existing axle or ordering one for a new build?": "¿Está reemplazando un eje existente o solicitando uno para una construcción nueva?",
  "As soon as possible": "Lo antes posible",
  "Axle Inc. chat": "Chat de Axle Inc.",
  "Axle parts": "Piezas para ejes",
  "Axle repair or replacement": "Reparación o reemplazo de ejes",
  "Axle replacement": "Reemplazo de eje",
  "Bearing service": "Servicio de rodamientos",
  "Boat trailer": "Remolque para embarcaciones",
  "Both": "Ambos",
  "Brake parts": "Piezas de frenos",
  "Brake service": "Servicio de frenos",
  "Broken down": "Averiado",
  "Business": "Negocio",
  "Business name": "Nombre del negocio",
  "Call": "Llamar",
  "Call me": "Llámeme",
  "Chat with us": "Chatee con nosotros",
  "Chinese (Mandarin)": "Chino (mandarín)",
  "Close chat": "Cerrar chat",
  "Commercial trailer": "Remolque comercial",
  "Construction": "Construcción",
  "Delivery/logistics": "Entrega/logística",
  "Do you have any trailer or axle information available?": "¿Tiene disponible alguna información sobre el remolque o el eje?",
  "Do you have photos of the trailer, axle tag, damaged part, or part you are trying to replace?": "¿Tiene fotos del remolque, la placa del eje, la pieza dañada o la pieza que intenta reemplazar?",
  "Do you have the axle tag, serial number, or measurements?": "¿Tiene la placa del eje, el número de serie o las medidas?",
  "Email me": "Envíeme un correo electrónico",
  "Enclosed trailer": "Remolque cerrado",
  "English": "Inglés",
  "Equipment rental": "Alquiler de equipos",
  "Equipment trailer": "Remolque para maquinaria",
  "First and last name": "Nombre y apellido",
  "Fix something": "Reparar algo",
  "Fleet support": "Soporte para flotas",
  "Flexible": "Flexible",
  "French": "Francés",
  "General trailer repair": "Reparación general de remolques",
  "Get service": "Obtener servicio",
  "Hi, welcome to Axle Inc. I can help with parts, axle orders, service, or trailer repair questions.\n\nIn case we get disconnected, what's the best phone number to reach you?": "Hola, bienvenido a Axle Inc. Puedo ayudarle con piezas, pedidos de ejes, servicio o preguntas sobre reparación de remolques.\n\nEn caso de que se corte la comunicación, ¿cuál es el mejor número de teléfono para contactarle?",
  "How many axles do you need?": "¿Cuántos ejes necesita?",
  "How many trailers do you operate or manage?": "¿Cuántos remolques opera o administra?",
  "How soon do you need the part?": "¿Qué tan pronto necesita la pieza?",
  "Hub, drum, or bearing parts": "Piezas de maza, tambor o rodamientos",
  "I can get photos later": "Puedo conseguir fotos más tarde",
  "I can send photos": "Puedo enviar fotos",
  "I have photos": "Tengo fotos",
  "I manage trailers for a business": "Administro remolques para un negocio",
  "I need parts": "Necesito piezas",
  "I need service or repair": "Necesito servicio o reparación",
  "I need someone to help identify the issue": "Necesito a alguien que me ayude a identificar el problema",
  "I need to order an axle": "Necesito pedir un eje",
  "I'm not sure": "No estoy seguro",
  "I'm not sure yet": "Todavía no estoy seguro",
  "Immediate need": "Necesidad inmediata",
  "Is the trailer currently usable or is it down?": "¿El remolque está en condiciones de uso o está fuera de servicio?",
  "Is this an immediate need or are you looking to set up ongoing support?": "¿Es una necesidad inmediata o busca establecer un soporte continuo?",
  "Is this trailer used for personal or business use?": "¿Este remolque se utiliza para uso personal o comercial?",
  "Just checking availability or pricing": "Solo estoy consultando disponibilidad o precios",
  "Landscaping": "Paisajismo",
  "Lighting or electrical repair": "Reparación de iluminación o sistema eléctrico",
  "Lights or electrical": "Luces o sistema eléctrico",
  "Livestock trailer": "Remolque para ganado",
  "Minimize chat": "Minimizar chat",
  "More than 25 trailers": "Más de 25 remolques",
  "Municipal/government": "Municipal/gobierno",
  "Next week": "La próxima semana",
  "No": "No",
  "No problem. Are you trying to fix something, replace something, or figure out what part you need?": "No hay problema. ¿Está intentando reparar algo, reemplazar algo o averiguar qué pieza necesita?",
  "No, I need help figuring it out": "No, necesito ayuda para identificarlo",
  "Not safe to use": "No es seguro para su uso",
  "Not sure": "No estoy seguro",
  "One axle": "Un eje",
  "One trailer": "Un remolque",
  "Ongoing support": "Soporte continuo",
  "Open chat — chat with us": "Abrir chat — chatee con nosotros",
  "Order an axle": "Pedir un eje",
  "Ordering for a new trailer/build": "Pedido para un remolque/construcción nueva",
  "Other": "Otro",
  "Our team has your details and will reach out shortly.": "Nuestro equipo tiene sus datos y se comunicará pronto.",
  "Parts ordering": "Pedido de piezas",
  "Personal": "Personal",
  "Planning ahead or just pricing": "Planificando con anticipación o solo consultando precios",
  "Please briefly describe what is happening or what you need repaired.": "Por favor, describa brevemente qué está sucediendo o qué necesita reparar.",
  "Please describe what you are working on or what problem you are trying to solve.": "Por favor, describa en qué está trabajando o qué problema intenta resolver.",
  "Please enter a response.": "Por favor, ingrese una respuesta.",
  "Please enter a valid email address.": "Por favor, ingrese una dirección de correo electrónico válida.",
  "Please enter a valid phone number.": "Por favor, ingrese un número de teléfono válido.",
  "Please keep the language to 80 characters or fewer.": "Por favor, mantenga el idioma en 80 caracteres o menos.",
  "Please share any details you know, such as axle capacity, hub face measurement, spring center measurement, bolt pattern, brake size, or trailer make/model.": "Por favor, comparta los detalles que conozca, como la capacidad del eje, la medida de la cara de la maza, la medida del centro de los muelles, el patrón de pernos, el tamaño de los frenos o la marca/modelo del remolque.",
  "Please share any part number, axle tag information, trailer make/model, or a short description of what you need.": "Por favor, comparta cualquier número de pieza, información de la placa del eje, marca/modelo del remolque o una breve descripción de lo que necesita.",
  "Portuguese": "Portugués",
  "Powered by Axle Inc. • We'll only use this to help you.": "Con tecnología de Axle Inc. • Solo usaremos esto para ayudarle.",
  "Preventive maintenance": "Mantenimiento preventivo",
  "Pricing/account setup": "Precios/configuración de cuenta",
  "RV/camper": "Vehículo recreativo (RV)/camper",
  "Replace a part": "Reemplazar una pieza",
  "Replacing an existing axle": "Reemplazando un eje existente",
  "Send": "Enviar",
  "Service or repair": "Servicio o reparación",
  "Spanish": "Español",
  "Suspension parts": "Piezas de suspensión",
  "Suspension repair": "Reparación de suspensión",
  "Text me": "Envíeme un mensaje de texto",
  "Thank you. What is your name?": "Gracias. ¿Cuál es su nombre?",
  "Thanks, {{first}}. Axle orders usually require a few fitment details, so our team will review this and contact you to confirm specs before pricing or ordering.": "Gracias, {{first}}. Los pedidos de ejes generalmente requieren algunos detalles de ajuste, por lo que nuestro equipo revisará esto y le contactará para confirmar las especificaciones antes de cotizar o realizar el pedido.",
  "Thanks, {{first}}. I'll send this to our parts team so they can check availability, pricing, and fitment. If you have photos of the axle tag or part, please have them ready when we contact you.": "Gracias, {{first}}. Enviaré esto a nuestro equipo de piezas para que puedan verificar la disponibilidad, el precio y el ajuste. Si tiene fotos de la placa del eje o de la pieza, téngalas a mano cuando le contactemos.",
  "Thanks, {{first}}. I'll send this to our service team so they can review the issue and contact you about next steps.": "Gracias, {{first}}. Enviaré esto a nuestro equipo de servicio para que puedan revisar el problema y contactarle sobre los siguientes pasos.",
  "Thanks, {{first}}. I'll send this to our team so they can help identify the right next step.": "Gracias, {{first}}. Enviaré esto a nuestro equipo para que puedan ayudarle a identificar el siguiente paso correcto.",
  "Thanks, {{first}}. I'll send this to our team so they can review your business needs and follow up about parts, service, or fleet support.": "Gracias, {{first}}. Enviaré esto a nuestro equipo para que puedan revisar las necesidades de su negocio y hacer un seguimiento sobre piezas, servicio o soporte de flotas.",
  "Thanks, {{first}}. What language would you prefer we use when we contact you?": "Gracias, {{first}}. ¿Qué idioma preferiría que usemos cuando le contactemos?",
  "This week": "Esta semana",
  "Three or more": "Tres o más",
  "Today": "Hoy",
  "Trailer care experts • Typically replies in minutes": "Expertos en cuidado de remolques • Generalmente responden en minutos",
  "Trailer hardware": "Herrajes para remolque",
  "Trailer inspection": "Inspección de remolque",
  "Trailer sales or repair": "Ventas o reparación de remolques",
  "Two axles": "Dos ejes",
  "Type the details here…": "Escriba los detalles aquí…",
  "Type the language": "Escriba el idioma",
  "Usable, but needs service": "En condiciones de uso, pero necesita servicio",
  "Utility trailer": "Remolque de carga general",
  "Vietnamese": "Vietnamita",
  "What can we help you with today?": "¿Con qué podemos ayudarle hoy?",
  "What do you need help with?": "¿Con qué necesita ayuda?",
  "What is the best email address for follow-up?": "¿Cuál es la mejor dirección de correo electrónico para el seguimiento?",
  "What is the best way for our team to follow up?": "¿Cuál es la mejor manera para que nuestro equipo haga el seguimiento?",
  "What is the name of your business?": "¿Cuál es el nombre de su negocio?",
  "What is your email address?": "¿Cuál es su dirección de correo electrónico?",
  "What kind of service or repair do you need?": "¿Qué tipo de servicio o reparación necesita?",
  "What type of business do you operate?": "¿Qué tipo de negocio opera?",
  "What type of part are you looking for?": "¿Qué tipo de pieza está buscando?",
  "What type of trailer is it?": "¿Qué tipo de remolque es?",
  "What type of trailer is this for?": "¿Para qué tipo de remolque es esto?",
  "When do you need the axle?": "¿Cuándo necesita el eje?",
  "When would you like to have it serviced?": "¿Cuándo le gustaría recibir el servicio?",
  "Which language do you prefer?": "¿Qué idioma prefiere?",
  "Within 2 to 4 weeks": "Dentro de 2 a 4 semanas",
  "Within 2 weeks": "Dentro de 2 semanas",
  "Yes": "Sí",
  "Yes, I have an axle tag or part number": "Sí, tengo una placa de eje o número de pieza",
  "Yes, I have an axle tag or serial number": "Sí, tengo una placa de eje o número de serie",
  "Yes, I have measurements": "Sí, tengo las medidas",
  "Yes, I know the trailer make/model": "Sí, conozco la marca/modelo del remolque",
  "Your answer": "Su respuesta",
  "there": "amigo",
};
